module.exports = __webpack_public_path__ + "static/media/leaf-maple.e4d8383d.svg";